import React from 'react';

interface StepActionsProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Wrapper for a step's Back/Continue buttons.
 * Below `md` it sticks to the bottom of the viewport so the primary action is
 * never buried in the scroll. Every mobile-only class is `max-md:` scoped, so
 * on `md+` this renders as a plain `flex` row with no extra styles.
 */
export const StepActions = ({ children, className = 'justify-between' }: StepActionsProps) => (
  <div
    className={`flex ${className} max-md:sticky max-md:bottom-0 max-md:z-10 max-md:py-3 max-md:bg-white max-md:border-t max-md:border-gray-200`}
  >
    {children}
  </div>
);
